
    // Copy-to-clipboard for code snippets
    document.querySelectorAll('.copy-btn').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const target = document.getElementById(btn.dataset.copy);
        if (!target) return;
        const text = target.querySelector('code')?.innerText ?? '';
        try {
          await navigator.clipboard.writeText(text);
          const original = btn.textContent;
          btn.textContent = 'Copied!';
          setTimeout(() => (btn.textContent = original), 1200);
        } catch {}
      });
    });

    // Playground
    const examples = {
      flowchart: `flowchart TD
  Start([User opens app]) --> Auth{Logged in?}
  Auth -- No --> Login[Show login]
  Auth -- Yes --> Home[Show home]
  Login --> Home
  Home --> End([Done])`,
      sequence: `sequenceDiagram
  participant U as User
  participant W as Widget
  participant M as Mermaid CDN
  U->>W: Page loads
  W->>M: import mermaid
  M-->>W: module
  W->>W: render(svg) inside Shadow DOM
  W-->>U: Diagram visible`,
      state: `stateDiagram-v2
  [*] --> Idle
  Idle --> Loading: fetch()
  Loading --> Success: 200
  Loading --> Error: 4xx/5xx
  Success --> Idle: reset
  Error --> Idle: retry`,
      er: `erDiagram
  USER ||--o{ POST : writes
  POST ||--|{ COMMENT : has
  USER ||--o{ COMMENT : authors
  USER {
    string id PK
    string email
  }
  POST {
    string id PK
    string title
    string userId FK
  }`,
      pie: `pie title Diagram types we love
  "Flowchart": 42
  "Sequence": 28
  "State": 18
  "Other": 12`,
    };

    const input = document.getElementById('pg-input');
    const output = document.getElementById('pg-output');
    const selector = document.getElementById('pg-example');

    let renderTimer = 0;
    function rerender() {
      clearTimeout(renderTimer);
      renderTimer = setTimeout(() => {
        if (window.MermaidEmbed) {
          window.MermaidEmbed.render(output, input.value);
        }
      }, 200);
    }

    input.addEventListener('input', rerender);
    selector.addEventListener('change', () => {
      input.value = examples[selector.value];
      rerender();
    });

    // Initial fill
    input.value = examples.flowchart;
    // Wait for widget side-effects, then render
    window.addEventListener('load', () => setTimeout(rerender, 50));
  